module.exports = __webpack_public_path__ + "static/media/complete_signin_icon.ad3f2ff7.svg";